
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { ValidationService } from '../../../../shared/validation/validation.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';
@Component({
  selector: 'bis-lieux-frserv',
  templateUrl: './lieux-frserv.component.html',
  styleUrls: ['./lieux-frserv.component.css']
})
export class LieuxFrservComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  private subLieuxFrserv: Subscription;
  private valeurTableauA4e_1: number[] = [];
  private valeurTableauA4e_2: number[] = [];
  private valeurTableauA4e_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    private validationService: ValidationService,
    public modeRenduService: ModeRenduService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.lieuxFrserv) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxFrserv', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      //Controles bloquants
        for (let index = 0; index < this.lieuxFrserv.length; index++) {
        this.ajoutValidateurCroiseLieuxFrserv(index);
        this.lieuxFrserv.controls[index].updateValueAndValidity();
      }
    
      // Tri apres rechargement questionnaire
      this.trierLieuxFrserv();
    
      // Calcul des totaux lieux Frserv
      this.subLieuxFrserv = this.lieuxFrserv.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          if (valeur instanceof Array) {

            this.valeurTableauA4e_1 = [];
            this.valeurTableauA4e_2 = [];
            this.valeurTableauA4e_3 = [];
            
            valeur.forEach((lieux, index) => {
              //Calcul totaux auto A4e
              this.calculAutoTotauxA4e(index, this.valeurTableauA4e_1, 'aaLieuFrservNbPerm', 'aaLieuFrservNbPermTot');      
              this.calculAutoTotauxA4e(index, this.valeurTableauA4e_2, 'aaLieuFrservNbPermEtp', 'aaLieuFrservNbPermEtpTot');      
              this.calculAutoTotauxA4e(index, this.valeurTableauA4e_3, 'aaLieuFrservNbVict', 'aaLieuFrservNbVictTot');      
            });
          }
        });
      this.lieuxFrserv.updateValueAndValidity();
    }, 1000);

  }

  ngOnDestroy(): void {
    if (this.subLieuxFrserv) {
      this.subLieuxFrserv.unsubscribe();
    }
  }

  get lieuxFrserv() {
    return this.rootForm.get('moyens').get('lieuxFrserv') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public ajouterLieuxFrserv() {
    // on récupère le nombre total avant ajout
    let nbLieux = this.formulaire.get('aaLieuFrservNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    this.lieuxFrserv.push(new UntypedFormGroup({
      aaLieuFrservRang: new UntypedFormControl(this.lieuxFrserv.length, Validators.required),
      aaLieuFrservCodCom: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuFrservCodCom')),
      aaLieuFrservQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuFrservQp')),
      aaLieuFrservNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuFrservNbPerm')),
      aaLieuFrservNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuFrservNbPermEtp')),
      aaLieuFrservNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuFrservNbVict'))
    }));
    this.step = this.lieuxFrserv.length - 1 ;
    this.ajoutValidateurCroiseLieuxFrserv(this.lieuxFrserv.length - 1);

    // on incrémente le nombre total de lieux
    this.formulaire.get('aaLieuFrservNb').setValue(++nbLieux);
  }

  private ajoutValidateurCroiseLieuxFrserv (index: number) {
    const currentForm: UntypedFormGroup = this.lieuxFrserv.controls[index] as UntypedFormGroup;
    currentForm.setValidators([
      this.validationService.ctrlA68Frserv,
      this.validationService.ctrlA69Frserv
    ]);
  }

  public supprimerLieuxFrserv(index?: number) {
    if (index >= 0) {
      const lieuxValeur = this.lieuxFrserv.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${lieuxValeur['aaLieuFrservCodCom']} ?`)) {
        this.lieuxFrserv.removeAt(index);
      }
    } else {
      this.lieuxFrserv.removeAt(this.lieuxFrserv.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de lieux
    this.formulaire.get('aaLieuFrservNb').setValue(this.lieuxFrserv.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierLieuxFrserv(): void {
    this.lieuxFrserv.controls.sort((a, b) => {
      if (a.get('aaLieuFrservRang').value < b.get('aaLieuFrservRang').value) {
            return -1;
      } else if (a.get('aaLieuFrservRang').value > b.get('aaLieuFrservRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.lieuxFrserv.length; index++) {
      this.lieuxFrserv.controls[index].get('aaLieuFrservRang').setValue(index);
    }
    this.trierLieuxFrserv();
  }

  private calculAutoTotauxA4e(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
    tabBoucle.splice(index,1,this.lieuxFrserv.controls[index].get(varBoucle).value);
    let sum = tabBoucle.reduce((a,b)=>a+b,0);
    this.formulaire.get(totBoucle).setValue(sum);
  }

}
